import { defineMessages } from 'react-intl';

export const storageLimitMessages = defineMessages({
  title: {
    id: 'storageLimit.title',
    defaultMessage: 'Storage limit',
  },
  storageLabel: {
    id: 'storageLimit.storageLabel',
    defaultMessage: 'Storage limit',
  },
  usedOutOfLimit: {
    id: 'storageLimit.usedOutOfLimit',
    defaultMessage: '{used} / {limit} used',
  },
});
